<template>
  <LibraryListItem class="pl-6">
    <div class="document-title text-textDarkest">
      {{ document.title }}
    </div>
    <div
      class="document-date"
      data-testid="revision-modified-date"
    >
      {{ document.revision_modified_at ? new Date(document.revision_modified_at).toLocaleDateString("en-US") : '' }}
    </div>
  </LibraryListItem>
</template>

<script setup>
import LibraryListItem from '@/components/shared/LibraryListItem.vue';

defineProps({
  document: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="less" scoped>
.document-title {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
